if (!customElements.get('header-component')) {
  class HeaderComponent extends HTMLElement {
    constructor() {
      super();
      this.logoBreakpoint = null;
      this.mobileBreakpoint = null;
    }

    connectedCallback() {
      this.menuContainer = this.querySelector('[header-menu-container]');
      this.logoElement = this.querySelector('[header-logo]');
      this.genderDesktop = this.querySelector('.header-gender-desktop');

      if (window.matchMedia('(max-width: 767px)').matches) {
        this.classList.add('header-mobile-mode');
      }

      if (this.menuContainer && this.logoElement) {
        this.setupLogoToggle();
      }
    }

    setupLogoToggle() {
      this.calculateBreakpoints();

      this.boundCheckWidth = () => this.checkMenuWidth();
      window.addEventListener('resize', this.boundCheckWidth);
    }

    calculateBreakpoints() {
      const headerComponent = this;
      const container = headerComponent.menuContainer;
      const nav = container.querySelector('nav');
      if (!nav) {
        headerComponent.setInitialState();
        return;
      }

      if (headerComponent.logoElement) headerComponent.logoElement.classList.remove('logo-compact');
      if (!window.matchMedia('(max-width: 767px)').matches) {
        headerComponent.classList.remove('header-mobile-mode');
      }

      requestAnimationFrame(() => {
        let navWidth = nav.scrollWidth;
        const headerBar = container.closest('.container-fluid');
        if (!headerBar) return;

        let headerWidth = headerBar.offsetWidth;
        let containerWidth = container.offsetWidth;

        if (typeof navWidth === 'string') navWidth = parseFloat(navWidth);
        if (typeof headerWidth === 'string') headerWidth = parseFloat(headerWidth);
        if (typeof containerWidth === 'string') containerWidth = parseFloat(containerWidth);

        if (isNaN(navWidth) || isNaN(headerWidth) || isNaN(containerWidth)) return;

        const otherElementsWidth = headerWidth - containerWidth;

        headerComponent.logoBreakpoint = otherElementsWidth + navWidth + 40;

        let genderMenuWidth = headerComponent.genderDesktop ? headerComponent.genderDesktop.offsetWidth : 0;
        if (typeof genderMenuWidth === 'string') genderMenuWidth = parseFloat(genderMenuWidth);
        if (isNaN(genderMenuWidth)) genderMenuWidth = 0;
        headerComponent.mobileBreakpoint = headerComponent.logoBreakpoint - genderMenuWidth - 40;

        headerComponent.setInitialState();
      });
    }

    setInitialState() {
      let windowWidth = window.innerWidth;
      if (typeof windowWidth === 'string') windowWidth = parseFloat(windowWidth);
      if (isNaN(windowWidth)) return;

      const isSmallScreen = window.matchMedia('(max-width: 767px)').matches;

      if (isSmallScreen || (this.mobileBreakpoint && windowWidth <= this.mobileBreakpoint)) {
        if (this.logoElement) this.logoElement.classList.remove('logo-compact');
        this.classList.add('header-mobile-mode');
      } else {
        if (this.logoElement) this.logoElement.classList.remove('logo-compact');
        this.classList.remove('header-mobile-mode');

        if (this.logoBreakpoint && windowWidth <= this.logoBreakpoint) {
          if (this.logoElement) this.logoElement.classList.add('logo-compact');
        }
      }
    }

    checkMenuWidth() {
      let logoBreakpoint = this.logoBreakpoint;
      let mobileBreakpoint = this.mobileBreakpoint;

      if (typeof logoBreakpoint === 'string') logoBreakpoint = parseFloat(logoBreakpoint);
      if (typeof mobileBreakpoint === 'string') mobileBreakpoint = parseFloat(mobileBreakpoint);

      if (!logoBreakpoint || isNaN(logoBreakpoint) || isNaN(mobileBreakpoint)) return;

      let windowWidth = window.innerWidth;
      if (typeof windowWidth === 'string') windowWidth = parseFloat(windowWidth);
      if (isNaN(windowWidth)) return;
      const currentState = this.getCurrentState();

      const buffer = 80;

      if (currentState === 'normal') {
        if (windowWidth <= logoBreakpoint) {
          if (this.logoElement) this.logoElement.classList.add('logo-compact');
        }
      } else if (currentState === 'logo-compact') {
        if (windowWidth > logoBreakpoint + buffer) {
          if (this.logoElement) this.logoElement.classList.remove('logo-compact');
        } else if (windowWidth <= mobileBreakpoint) {
          if (this.logoElement) this.logoElement.classList.remove('logo-compact');
          this.classList.add('header-mobile-mode');
        }
      } else if (currentState === 'header-mobile-mode') {
        if (windowWidth > mobileBreakpoint + buffer) {
          this.classList.remove('header-mobile-mode');
          if (this.logoElement) this.logoElement.classList.add('logo-compact');
        }
      }
    }

    getCurrentState() {
      if (this.classList.contains('header-mobile-mode')) {
        return 'header-mobile-mode';
      } else if (this.logoElement && this.logoElement.classList.contains('logo-compact')) {
        return 'logo-compact';
      }
      return 'normal';
    }

    disconnectedCallback() {
      if (this.boundCheckWidth) {
        window.removeEventListener('resize', this.boundCheckWidth);
      }
    }
  }
  customElements.define('header-component', HeaderComponent);
}